import {DICT_KEY, getModel, setModel} from "../../../utils/constants";
import moment from "moment"
import ModelUtils from "../../../utils/ModelUtils";
import SupplierBillService from "./SupplierBillService";
import SupplierService from "../../base/supplier/SupplierService";

const MODEL_KEY = DICT_KEY.BILL_SUPPLIER;
const storageModel = getModel(MODEL_KEY);
const cacheAble = false;
const initState = {
    searchParam: {},
    supplierList: [],
    supplierTotal: {},
    pageInfo: {
        pageSize: 10,
        pageNum: 1,
        total: -1
    },
    accountList: [],
    accountToatl: {},
    selectedSupplierBill: null,
    selectedSupplierRowKeysBill: [],
    selectedAccount: null,
    selectedAccountRowKeys: [],
    ModelParams: {//模态框基本参数
        title: "",
        Visible: false,
        type: ""
    },
    ModelVisible: false,//模态框状态
    BillParams: {},//账单参数
    BillModelType: false,
    BillTable: [],
    BillTableKey: [],
    BillList: [],
    BillPage: {},
    tabsKey: "1",
    tabsList: [],
    tabParams: null,
    tabPage: {}
};
const supplierBillModel = {
    state: cacheAble && storageModel ? storageModel : initState,
    reducers: {
        init(state,) {
            state.selectedAccount = null;
            state.selectedAccountRowKeys = [];
        },
        setSearchParam(state, payload) {
            state.searchParam = {...payload}
            setModel(MODEL_KEY, {...state})
        },
        setSupplierList(state, payload) {
            state.supplierList = payload
            setModel(MODEL_KEY, {...state})
        },
        setSupplierTotal(state, payload) {
            state.supplierTotal = payload
            setModel(MODEL_KEY, {...state})
        },
        setPageInfo(state, payload) {
            state.pageInfo = payload
            setModel(MODEL_KEY, {...state})
        },
        setSelectedSupplierBill(state, payload) {
            state.selectedSupplierBill = payload;
            setModel(MODEL_KEY, {...state})
        },
        setSelectedSupplierRowKeysBill(state, payload) {
            state.selectedSupplierRowKeysBill = payload
            setModel(MODEL_KEY, {...state})
        },
        setAccountList(state, payload) {
            state.accountList = payload
            setModel(MODEL_KEY, {...state})
        },
        setAccountToatl(state, payload) {
            state.accountToatl = payload
            setModel(MODEL_KEY, {...state})
        },
        setSelectedAccount(state, payload) {
            state.selectedAccount = payload;
            setModel(MODEL_KEY, {...state});
        },
        setSelectedAccountRowKeys(state, payload) {
            state.selectedAccountRowKeys = payload;
            setModel(MODEL_KEY, {...state});
        },
        setModelVisible(state, payload) {
            state.ModelVisible = payload
            setModel(MODEL_KEY, {...state})
        },
        setModelParams(state, payload) {//模态框样式调整
            state.ModelParams = {...state.ModelParams, ...payload}
            setModel(MODEL_KEY, {...state})

        },
        /*setBillParams(state, payload) {
            if (Object.keys(payload).length != 0) {
                state.BillParams = {...state.BillParams, ...payload}
            } else {
                state.BillParams = {...payload}
            }
            // console.log(state.BillParams)
            setModel(MODEL_KEY, {...state})
        },*/
        setTabsKey(state, payload) {
            state.tabsKey = payload;
            setModel(MODEL_KEY, {...state})

        },
        setTabsList(state, payload) {
            state.tabsList = payload;
            setModel(MODEL_KEY, {...state});
        },
        setTabParams(state, payload) {
            state.tabParams = payload;
            // setModel(MODEL_KEY, {...state});
        },
        setTabPage(state, payload) {
            state.tabPage = payload;
        },
        setBillParams(state, payload) {
            // if(Object.keys(payload).length!=0){
            //     console.log("走这里吗")
            //     state.BillParams = {...state.BillParams,...payload}
            // }else{
            state.BillParams = {...payload}
            // }
            // console.log(state.BillParams)
            setModel(MODEL_KEY, {...state})
        },
        setBillModelType(state, payload) {
            state.BillModelType = payload
            setModel(MODEL_KEY, {...state})
        },
        setBillTable(state, payload) {
            state.BillTable = payload
            setModel(MODEL_KEY, {...state})
        },
        setBillTableKey(state, payload) {
            state.BillTableKey = payload
            setModel(MODEL_KEY, {...state})
        },
        setBillList(state, payload) {
            state.BillList = payload
            setModel(MODEL_KEY, {...state})
        },
        setBillPage(state, payload) {
            state.BillPage = payload
            setModel(MODEL_KEY, {...state})
        },
    },
    effects: () => ({
        async loadSupplierList({showMsg = true, duration = 5, data}) {
            const funName = "加载供应商";
            const sucMsg = funName + "成功!";
            const failMsg = funName + "失败!";
            data.pageSize = data.pageSize ? data.pageSize : 15
            data.pageNum = data.pageNum ? data.pageNum : 1
            const func = async () => {
                let retData = await SupplierBillService.loadSupplierList(data);
                const {info, statistic} = retData[0];
                const {list, ...page} = info
                list.forEach((el, index) => el.key = el.id);
                this.setSupplierList(list);
                this.setSupplierTotal(statistic);
                this.setPageInfo(page);
                return retData
            };
            return await ModelUtils.execute({
                funName, sucMsg, failMsg, showMsg, duration
            }, func);
        },
        async loadSupplierAccountList({showMsg = true, duration = 5, data}) {
            const funName = "加载供应商账户";
            const sucMsg = funName + "成功!";
            const failMsg = funName + "失败!";
            if (!!data) {
                const func = async () => {
                    let retData = await SupplierService.findAccountAll(data);
                    let {list, statistic} = retData[0]
                    if (list) {
                        list.forEach(el => el.key = el.id);
                    }
                    this.setAccountList(list);
                    this.setAccountToatl(statistic)
                    return retData
                };
                return await ModelUtils.execute({
                    funName, sucMsg, failMsg, showMsg, duration
                }, func);
            } else {
                this.setAccountList([]);
            }

        },
        async enableOrDisableAccount({showMsg = true, duration = 5, data}, {supplierBill}) {
            const funName = "更新供应商账户状态";
            const sucMsg = funName + "成功!";
            const failMsg = funName + "失败!";
            const {id, accountStatus} = data;
            //调用接口
            const func = async () => {
                let retData = await SupplierService.accountEnableOrDisable(data);
                //更新本地数据
                const {accountList} = supplierBill;
                const mapAccList = accountList.map(el => {
                    if (el.id === id) {
                        return {...el, accountStatus: accountStatus ? 1 : 0}
                    }
                    return el;
                });
                this.setAccountList(mapAccList);
                return retData
            };
            return await ModelUtils.execute({
                funName, sucMsg, failMsg, showMsg, duration
            }, func);

        },
        async adjustAccount({showMsg = true, duration = 5, data}, {supplierBill}) {
            const funName = "调整授信额度";
            const sucMsg = funName + "成功!";
            const failMsg = funName + "失败!";
            const func = async () => {
                let retData = await SupplierService.adjustAccount(data);

                //重新加载供应商账户
                const {selectedSupplierBill} = supplierBill;
                await this.loadSupplierAccountList({showMsg: false, data: selectedSupplierBill.id});
                return retData
            };
            return await ModelUtils.execute({
                funName, sucMsg, failMsg, showMsg, duration
            }, func);
        },
        async fillAccount({showMsg = true, duration = 5, data}, {supplierBill}) {
            const funName = "账户充值";
            const sucMsg = funName + "成功!";
            const failMsg = funName + "失败!";
            const func = async () => {
                let retData = await SupplierService.fillAccount(data);

                //重新加载供应商账户
                const {selectedSupplierBill} = supplierBill;
                await this.loadSupplierAccountList({showMsg: false, data: selectedSupplierBill.id});
                return retData

            };
            return await ModelUtils.execute({
                funName, sucMsg, failMsg, showMsg, duration
            }, func);
        },
        async transferAccount({showMsg = true, duration = 5, data}, {supplierBill}) {
            const funName = "账户转账";
            const sucMsg = funName + "成功!";
            const failMsg = funName + "失败!";
            const func = async () => {
                let retData = await SupplierService.transferAccount(data);
                // console.log(retData)

                //重新加载供应商账户
                const {selectedSupplierBill} = supplierBill;
                await this.loadSupplierAccountList({showMsg: false, data: selectedSupplierBill.id});
                return retData
            };
            return await ModelUtils.execute({
                funName, sucMsg, failMsg, showMsg, duration
            }, func);
        },
        async SupplierResizeLimitList({showMsg = true, duration = 5, data}, {supplierBill}) {
            const funName = "调额记录";
            const sucMsg = funName + "成功!";
            const failMsg = funName + "失败!";
            // return console.log(data)
            const func = async () => {
                let retData = await SupplierService.SupplierResizeLimitList(data);
                //重新加载客户账户
                let {list, ...page} = retData
                // console.log(retData)
                list.forEach(el => el.key = el.id);
                this.setTabsList(list);
                this.setTabPage(page)
                return retData
            };
            return await ModelUtils.execute({
                funName, sucMsg, failMsg, showMsg, duration
            }, func);
        },
        //加载转账记录
        async SupplierTransferAccountsList({showMsg = true, duration = 5, data}, {supplierBill}) {
            const funName = "加载转账记录";
            const sucMsg = funName + "成功!";
            const failMsg = funName + "失败!";
            // return console.log(data)
            const func = async () => {
                let retData = await SupplierService.SupplierTransferAccountsList(data);
                //重新加载客户账户
                let {list, ...page} = retData
                // console.log(retData)
                list.forEach(el => el.key = el.id);
                this.setTabsList(list);
                this.setTabPage(page)
                return retData
            };
            return await ModelUtils.execute({
                funName, sucMsg, failMsg, showMsg, duration
            }, func);
        },
        //加载充值记录
        async SupplierRechargeList({showMsg = true, duration = 5, data}, {supplierBill}) {
            const funName = "充值记录";
            const sucMsg = funName + "成功!";
            const failMsg = funName + "失败!";
            // return console.log(data)
            const func = async () => {
                let retData = await SupplierService.SupplierRechargeList(data);
                //重新加载客户账户
                let {list, ...page} = retData
                // console.log(retData)
                list.forEach(el => el.key = el.id);
                this.setTabPage(page)
                this.setTabsList(list);
                return retData
            };
            return await ModelUtils.execute({
                funName, sucMsg, failMsg, showMsg, duration
            }, func);
        },
        //加载账单记录
        async loadBillList({showMsg = true, duration = 5, data}, {supplierBill}) {
            const funName = "加载账单记录";
            const sucMsg = funName + "成功!";
            const failMsg = funName + "失败!";
            // return console.log(data)
            data.pageSize = data.pageSize || 15;
            data.pageNum = data.pageNum || 1
            const func = async () => {
                let retData = await SupplierBillService.loadBillList(data);
                //重新加载客户账户
                let {list, ...page} = retData
                // console.log(list,page)
                list.forEach(el => el.key = el.id);
                this.setBillList(list);
                this.setBillPage(page)
                return retData
            };
            return await ModelUtils.execute({
                funName, sucMsg, failMsg, showMsg, duration
            }, func);
        },
        //账单平账
        async BillFlat({showMsg = true, duration = 5, data}, {supplierBill}) {
            const funName = "账单平账";
            const sucMsg = funName + "成功!";
            const failMsg = funName + "失败!";
            // return console.log(data)
            const func = async () => {
                let retData = await SupplierBillService.BillFlat(data);
                const {selectedSupplierBill} = supplierBill;
                this.loadBillList({showMsg: false, data: {relationId: selectedSupplierBill.id}})
                //重新加载客户账户
                // let {list,...page} = retData
                // console.log(list,page)
                // list.forEach(el => el.key = el.id);
                // this.setBillList(list);
                // this.setBillPage(page)
                return retData
            };
            return await ModelUtils.execute({
                funName, sucMsg, failMsg, showMsg, duration
            }, func);
        },
    })
}


export default supplierBillModel;